import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const AudioVideoFeature = ({ refs }) => {
    const paste = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.audioVideo.description.1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.audioVideo.description.2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.audioVideo.description.3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.audioVideo}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'page.home.feature.audioVideo.tag'}
                id={'section-audioVideo'}
                img={`/static/asset/img/features/apel_vboard.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-audioVideo-section'}
                title={'page.home.feature.audioVideo.description'}
                explanations={paste}
            />
        </>
    );
};

export default AudioVideoFeature;
